import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from '../../../../../shared/services/common.service';

@Component({
  selector: 'app-viewandreplygrievancebyia',
  templateUrl: './viewandreplygrievancebyia.component.html',
  styleUrl: './viewandreplygrievancebyia.component.css'
})
export class ViewandreplygrievancebyiaComponent {
  form: FormGroup;
  msmeDetailsForm: FormGroup;
  GrievanceList: any[] = [];
  grievanceId = sessionStorage.getItem("GrievanceId");
  statusList: any[] = [];
  grievanceReply: any = {};

  hideDownload: boolean = true;
  hideFileUpload: boolean = true;
  showDownloadBtn: boolean = false;

  grievanceDocumentFile: File | null = null;
  grievanceDocumentfileErrors: { typeError: boolean; sizeError: boolean } = { typeError: false, sizeError: false };
  maxSizeInMB = 10;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private apiService: ApiService,
    private toastrService: ToastrService, private commonService: CommonService,
    public dialog: MatDialog) {
    this.form = this.fb.group({      
      reply: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(500), Validators.pattern(this.commonService.grievanceDescription)]),
      status: new FormControl('', [Validators.required]),
      documents: this.fb.array([]),
      resolvedDocumentName: new FormControl(''),
      resolvedDocumentPath: new FormControl(''),
    });

    this.msmeDetailsForm = this.fb.group({
      msmeGrievanceId: new FormControl(''),
      grievanceName: new FormControl(''),
      subject: new FormControl(''),
      description: new FormControl(''),
      createdDate: new FormControl(''),
      documentName: new FormControl(''),
      documentPath: new FormControl(''),
    });
  }

  get f() {
    return this.form.controls;
  }

  ngOnInit(): void {
    this.msmeDetailsForm.disable();
    this.LoadGrievanceStatus(); 
    if (this.grievanceId) {
      this.LoadGrievanceReply(this.grievanceId);
      this.LoadDetails(this.grievanceId);
    }   
  }  

  LoadDetails(grievanceId: string) {
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.GETGRIEVANCEBYID, { grievanceId }).subscribe(
      (result) => {
        if (result.status) {
          this.GrievanceList = result.data;
          this.msmeDetailsForm.patchValue(this.GrievanceList);
          if (result.data.documentName != null) {
            //enable Download option in html and hide file upload
            this.hideDownload = false;
          } else {
            //Disabled Download option and hide file upload
            this.hideDownload = true;
          }
        }
      }
    );
  }

  LoadGrievanceStatus() {
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.GETGRIEVANCESTATUS).subscribe(
      (result) => {
        if (result.status) {
          this.statusList = result.data;
        }
      }
    );
  }

  onGrievanceFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length) {
      this.grievanceDocumentFile = input.files[0];

      // Reset file errors
      this.grievanceDocumentfileErrors = { typeError: false, sizeError: false };

      // Check file type (only images like jpg, png)
      const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf', 'application/zip'];
      if (!validTypes.includes(this.grievanceDocumentFile.type)) {
        this.grievanceDocumentfileErrors.typeError = true;
      }

      // Check file size (maxSizeInMB limit)
      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024;
      if (this.grievanceDocumentFile.size > maxSizeInBytes) {
        this.grievanceDocumentfileErrors.sizeError = true;
      }
    }
  }

  onDownload() {
    var filePath = this.msmeDetailsForm.get('documentPath')?.value;
    var fileName = this.msmeDetailsForm.get('documentName')?.value;
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    });
  }

  onDownloadReply() {
    var filePath = this.form.get('resolvedDocumentPath')?.value;
    var fileName = this.form.get('resolvedDocumentName')?.value;
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'ReviewerComment_'+fileName || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    });
  }

  onPressBack() {
    this.router.navigate(['/iagrievanceDashboard']);
  }

  OnReset() {
    this.form.clearValidators();
    this.form.reset();
  }

  onSubmit() {
    if (this.form.valid) {
      const formData = new FormData();
      formData.append('grievanceId', this.msmeDetailsForm.get('msmeGrievanceId')?.value);
      formData.append('reply', this.form.get('reply')?.value);
      formData.append('status', this.form.get('status')?.value);
      if (this.grievanceDocumentFile) {
        formData.append('grievanceFile', this.grievanceDocumentFile, this.grievanceDocumentFile.name);
      }
      this.apiService.postRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.SAVEGRIEVANCEREPLYBYIA, formData).subscribe(
        (result) => {
          if (result.status) {
            this.toastrService.success("Data saved successfully.");
            window.location.reload();
          }
        }
      );
      //this.router.navigate(['/iagrievanceDashboard']);
    } else {
      this.form.markAllAsTouched();
    }
  }

  LoadGrievanceReply(grievanceId: string) {
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.GETGRIEVANCEREPLYFORIA, { grievanceId }).subscribe(
      (result) => {
        if (result.status) {
          this.grievanceReply = result.data;
          this.form.patchValue(this.grievanceReply, { emitEvent: false });
          if (this.grievanceReply.statusName != 'Pending') { //IsReplied=true
            if (this.grievanceReply.resolvedDocumentName != null) {
              this.showDownloadBtn = true;
              //show download button
              this.form.disable();
            }
            else {
              this.hideFileUpload = true;
              //hide  control
              this.form.disable();
            }
          }
          else {
            this.hideFileUpload = false;
            //show fileupload
          }
        }
      }
    );
  }

  openFilePreviewDialog(): void {
    var filePath = this.msmeDetailsForm.get('documentPath')?.value;
    var fileName = this.msmeDetailsForm.get('documentName')?.value;

    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }

  openReviewerFilePreviewDialog(): void {
    var filePath = this.form.get('resolvedDocumentPath')?.value;
    var fileName = this.form.get('resolvedDocumentName')?.value;

    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }
}
